(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentDetailController', TreatmentDetailController);

    TreatmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Treatment', 'Practice', 'Coupon'];

    function TreatmentDetailController($scope, $rootScope, $stateParams, previousState, entity, Treatment, Practice, Coupon) {
        var vm = this;

        vm.treatment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('getwellApp:treatmentUpdate', function(event, result) {
            vm.treatment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
